import React from 'react'
import { ArbeitsorgRow } from '@myapp/contract'
import { DataTable, Pagination, TableColumn } from '../../../../shared/ui'
import { ORGANISATIONSTYP_LABELS } from '../model/constants'

function fmtTermin(row: ArbeitsorgRow): string {
  const hasSameDay = row.dateFrom === row.dateTo
  const datePart = hasSameDay
    ? formatDe(row.dateFrom)
    : `${formatDe(row.dateFrom)} - ${formatDe(row.dateTo)}`

  if (hasSameDay && row.timeFrom && row.timeTo) {
    return `${datePart} ${row.timeFrom} - ${row.timeTo}`
  }
  return datePart
}

function formatDe(iso: string): string {
  const [y, m, d] = iso.split('-')
  return `${d}.${m}.${y}`
}

const COLUMNS: TableColumn<ArbeitsorgRow>[] = [
  {
    key: 'termin',
    header: 'Termin',
    headerClassName: 'min-w-[180px]',
    cellClassName: 'whitespace-nowrap',
    render: (r) => fmtTermin(r),
  },
  {
    key: 'technician',
    header: 'Handwerker',
    headerClassName: 'min-w-[130px]',
    render: (r) => <span className="font-medium text-[#004494]">{r.technicianName || '–'}</span>,
  },
  {
    key: 'organisationstyp',
    header: 'Organisationstyp',
    headerClassName: 'min-w-[160px]',
    render: (r) => (
      <span className="text-[#004494]">{ORGANISATIONSTYP_LABELS[r.organisationType]}</span>
    ),
  },
  {
    key: 'bereich',
    header: 'Bereich',
    headerClassName: 'min-w-[100px]',
    render: (r) => r.bereich ?? <span className="text-gray-400">–</span>,
  },
  {
    key: 'istStd',
    header: 'Ist-Std.',
    headerClassName: 'min-w-[90px] text-center',
    cellClassName: 'text-center whitespace-nowrap',
    render: (r) =>
      r.istStd != null ? (
        r.istStd.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
      ) : (
        <span className="text-gray-400">–</span>
      ),
  },
  {
    key: 'wert',
    header: 'Wert',
    headerClassName: 'min-w-[80px] text-center',
    cellClassName: 'text-center',
    render: () => <span className="text-gray-400">–</span>,
  },
]

interface ArbeitsorganisationListProps {
  items: ArbeitsorgRow[]
  meta: { page: number; limit: number; total: number } | undefined
  isLoading?: boolean
  isFetching?: boolean
  page: number
  onPageChange: (p: number) => void
}

export const ArbeitsorganisationList: React.FC<ArbeitsorganisationListProps> = ({
  items,
  meta,
  isLoading,
  isFetching,
  page,
  onPageChange,
}) => {
  const totalPages = meta ? Math.ceil(meta.total / meta.limit) : 0
  return (
    <div className="flex flex-col">
      <DataTable<ArbeitsorgRow>
        columns={COLUMNS}
        rows={items}
        getRowKey={(r) => r.id}
        isLoading={isLoading}
        isFetching={isFetching}
        emptyMessage="Keine Daten"
        compact
        minWidth={900}
      />
      <Pagination
        page={page}
        totalPages={totalPages}
        onPageChange={onPageChange}
        isFetching={isFetching}
        disabled={isLoading}
      />
    </div>
  )
}
